module.exports = __webpack_public_path__ + "static/media/logofull.0dd376b0.png";